import React from 'react';
import { useNavigate } from 'react-router-dom';
import BudgetCheckStep from '@/components/journey/BudgetCheckStep';

const BudgetTool = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    // Navigate back to the current Tools hub page
    navigate('/public-tools');
  };

  const handleSkip = () => {
    navigate('/public-tools');
  };

  const handleBack = () => {
    navigate('/public-tools');
  };

  return (
    <BudgetCheckStep 
      onContinue={handleContinue}
      onSkip={handleSkip}
      onBack={handleBack}
    />
  );
};

export default BudgetTool;
